<template>
  <div class="page-loader flex-column">
    <div class="d-flex align-items-center mt-5">
      <span
        class="spinner-border"
        style="color: var(--primary-color);"
        role="status"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'Loader',
  props: {
    timeout: { Type: Number, default: 500 }
  },
  mounted() {
    document.body.classList.add('page-loading')
    setTimeout(() => {
      document.body.classList.remove('page-loading')
    }, this.timeout)
  }
})
</script>
